// extracted by mini-css-extract-plugin
module.exports = {"row-container":"_2akca","row-wrapper":"_31SzJ","wrapper":"_2aqYn"};